import { render } from "./ExpertStatisticsReportList.vue?vue&type=template&id=8bcee0c2"
import script from "./ExpertStatisticsReportList.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsReportList.vue?vue&type=script&lang=js"

import "./ExpertStatisticsReportList.vue?vue&type=style&index=0&id=8bcee0c2&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__